module.exports = __webpack_public_path__ + "assets/img/moduliu-monitoringas.86f8d969.webp";